import { render } from "./App.vue?vue&type=template&id=68cf8688"
const script = {}

import "./App.vue?vue&type=style&index=0&id=68cf8688&lang=css"

import exportComponent from "X:\\GRV\\PeD\\WebCNCMonitor\\dashboard\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__